import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const ampAiPlatformPlugin = createPlugin({
  id: 'amp-ai-platform',
  routes: {
    root: rootRouteRef,
  },
});

export const AmpAiPlatform = ampAiPlatformPlugin.provide(
  createRoutableExtension({
    name: 'AmpAiPlatformPage',
    component: () =>
      import('./components/AmpAiPlatformApp').then(m => m.AmpAiPlatformApp),
    mountPoint: rootRouteRef,
  }),
);
